import React, { useContext, useEffect, useState } from "react";
import { Button, Spinner } from "grommet";
import ContactFormModal from "../LearningPaths/ContactFormModal";
import { Box, Heading, Text, Layer } from "grommet";
import axios from "../../config/adminAxios";
import API_URL from "../../config/config";
import { getUserName } from "../../services/dashboardService";
import { AuthContext } from "../../contexts/AuthContext";

export const DedicatedLearningButton = ({ user_id }) => {
  const [showModal, setShowModal] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const { user, userName: contextUserName } = useContext(AuthContext);
  const handleOpenModal = () => {
    if (!user) { setShowAuthModal(true); return; }
    setShowModal(true);
  };
  const handleCloseModal = () => setShowModal(false);
  const [isLoading, setIsLoading] = useState(false);
  const [userName, setUserName] = useState("");
  const [userCountry, setUserCountry] = useState("");
  const [popup, setPopup] = useState({
    message: "",
    status: "",
    visible: false,
  });

  const fetchUserData = async () => {
    try {
      const response = await axios.get(`${API_URL}/user/getUser/${user_id}`);
      setUserCountry(response.data.user?.country ?? "");
    } catch (error) {
      console.error("Error loading dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchData = async () => {
    try {
      const name = contextUserName
        ? contextUserName
        : await getUserName(user_id);
      setUserName(name);
    } catch (error) {
      console.error("Error loading dashboard data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleRateLimit = (retryAt) => {
    setShowModal(false);
    window.dispatchEvent(new CustomEvent("app:rate-limited", { detail: { retryAt } }));
  };

  const handleFormSubmit = async (formData) => {
    setIsLoading(true);
    formData = { ...formData, user_id: user_id };

    try {
      await axios.post(
        `${API_URL}/dashboard/request-dedicated-learning`,
        formData,
        { suppressRateLimitEvent: true },
      );
      setIsLoading(false);
      setPopup({
        message:
          "Thanks for contacting HPE Education Services. One of our friendly staff will get in touch with you shortly. If the request is urgent, please contact your local HPE Education Services office",
        status: "normal",
        visible: true,
      });
      return true;
    } catch (error) {
      console.error("Error submitting the form:", error);
      setIsLoading(false);
      if (error.response?.status === 429) {
        const retryAfter = error.response.headers["retry-after"];
        const retryAt = retryAfter ? Date.now() + parseInt(retryAfter, 10) * 1000 : null;
        return { rateLimited: true, retryAt };
      } else {
        setPopup({
          message:
            "There was an error processing your request. Please try again.",
          status: "critical",
          visible: true,
        });
      }
      return false;
    }
  };
  if (isLoading) {
    return <Spinner />;
  }
  return (
    <Box>
      <Button
        label="To request customised/dedicated learning experience click here"
        onClick={handleOpenModal}
        primary
      />
      {showAuthModal && (
        <Layer onEsc={() => setShowAuthModal(false)} onClickOutside={() => setShowAuthModal(false)}>
          <Box pad="medium" gap="small" width="medium">
            <Heading level={3} margin="none">Account Required</Heading>
            <Text>Please create an account to explore HPE Digital Skill Advisor and submit a support ticket.</Text>
            <Box direction="row" justify="end">
              <Button label="Close" primary onClick={() => setShowAuthModal(false)} />
            </Box>
          </Box>
        </Layer>
      )}
      {showModal && (
        <ContactFormModal
          username={userName}
          email={user.email}
          country={userCountry}
          onClose={handleCloseModal}
          onSubmit={handleFormSubmit}
          onRateLimit={handleRateLimit}
        />
      )}
      {popup.visible && (
        <Layer
          onEsc={() => setPopup({ ...popup, visible: false })}
          onClickOutside={() => setPopup({ ...popup, visible: false })}
        >
          <Box pad="medium" gap="small" width="medium">
            <Heading level={3} margin="none">
              {popup.status === "normal" ? "Success" : "Error"}
            </Heading>
            <Text>{popup.message}</Text>
            <Box direction="row" gap="medium" justify="end">
              <Button
                label="Close"
                onClick={() => setPopup({ ...popup, visible: false })}
                primary
              />
            </Box>
          </Box>
        </Layer>
      )}
    </Box>
  );
};
